import React from 'react'

function FollowUpnote() {
  return (
    <div>FollowUpnote</div>
  )
}

export default FollowUpnote